import React          from 'react';
import DashboardStore from '@widesk-ui/stores/DashboardStore';

type DashboardContextType = { dashboardStore?: DashboardStore; }

const DashboardContext = React.createContext<DashboardContextType>({ dashboardStore: undefined });

export default DashboardContext;
